import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { ContactDetailsResponse } from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

type QueryKey = [string, string, string | undefined];

export function useDescribeContactDetails(
  contactId: string,
  cognismContactId?: string,
  options?: UseQueryOptions<ContactDetailsResponse, unknown, ContactDetailsResponse, QueryKey>,
) {
  const api = useIntegrationApi();
  return useQuery(
    ["contactDetails", contactId, cognismContactId],
    async () => {
      const response = await api.describeContactDetails({
        contactDetailsRequest: { contactId, cognismContactId },
      });
      return response;
    },
    options,
  );
}
